/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Draft_Count_SwappedInputs */

const en_us2_draft_count_swapped = /** @type {(inputs: Draft_Count_SwappedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 swap`);
	return /** @type {LocalizedString} */ (`${i?.count} swaps`)
	
};

const pt_br2_draft_count_swapped = /** @type {(inputs: Draft_Count_SwappedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 troca`);
	return /** @type {LocalizedString} */ (`${i?.count} trocas`)
	
};

const es_419_draft_count_swapped = /** @type {(inputs: Draft_Count_SwappedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 cambio`);
	return /** @type {LocalizedString} */ (`${i?.count} cambios`)
	
};

const pt_pt2_draft_count_swapped = /** @type {(inputs: Draft_Count_SwappedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 troca`);
	return /** @type {LocalizedString} */ (`${i?.count} trocas`)
	
};

const fr_fr2_draft_count_swapped = /** @type {(inputs: Draft_Count_SwappedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 remplacement`);
	return /** @type {LocalizedString} */ (`${i?.count} remplacements`)
	
};

const de_de2_draft_count_swapped = /** @type {(inputs: Draft_Count_SwappedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 Tausch`);
	return /** @type {LocalizedString} */ (`${i?.count} Tausche`)
	
};

const it_it2_draft_count_swapped = /** @type {(inputs: Draft_Count_SwappedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 cambio`);
	return /** @type {LocalizedString} */ (`${i?.count} cambi`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "1 swap" |
* | * | "{count} swaps" |
*
* @param {Draft_Count_SwappedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_count_swapped = /** @type {((inputs: Draft_Count_SwappedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Count_SwappedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_count_swapped(inputs)
	if (locale === "es-419") return es_419_draft_count_swapped(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_count_swapped(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_count_swapped(inputs)
	if (locale === "de-DE") return de_de2_draft_count_swapped(inputs)
	if (locale === "it-IT") return it_it2_draft_count_swapped(inputs)
	return en_us2_draft_count_swapped(inputs)
});
export { draft_count_swapped as "draft.count_swapped" }